let stopPropagation = (evt: { stopPropagation?: any, cancelBubble?: boolean }) => {
  stopPropagation = evt.stopPropagation
    ? evt => evt.stopPropagation()
    : evt => { evt.cancelBubble = true }
  stopPropagation(evt)
}

let preventDefault = (evt: { stopPropagation?: any, cancelBubble?: boolean, preventDefault?: any, returnValue?: boolean }) => {
  preventDefault = evt.preventDefault
    ? evt => evt.preventDefault()
    : evt => { evt.returnValue = true }
  preventDefault(evt)
}

export default (elem: { detachEvent: (arg0: string, arg1: { (evt: any): void; (evt: any): void; (evt: any): void }) => void; releaseCapture: () => void; setCapture: () => void; attachEvent: (arg0: string, arg1: { (evt: any): void; (evt: any): void; (evt: any): void }) => void }, evt: { clientX?: any; clientY?: any; stopPropagation?: any; cancelBubble?: boolean; preventDefault?: any; returnValue?: boolean }, endCallback: () => void) => {
  const $elem = $(elem)
  elem = $elem[0]

  stopPropagation(evt)
  preventDefault(evt)

  const scroll = {
    left: $(window).scrollLeft(),
    top: $(window).scrollTop()
  }

  const ww = $(window).width()
  const wh = $(window).height()

  const offset = $elem.offset()
  const ew = $elem.width()
  const eh = $elem.height()

  const dx = evt.clientX - (offset.left - scroll.left)
  const dy = evt.clientY - (offset.top - scroll.top)

  const minX = 0
  const maxX = ww - ew
  const minY = 0
  const maxY = wh - eh

  let first = true

  const moveHandler = (evt: { clientX: number; clientY: number }) => {
    let x = evt.clientX - dx
    let y = evt.clientY - dy

    x = Math.min(maxX, Math.max(minX, x))
    y = Math.min(maxY, Math.max(minY, y))

    $elem.offset({ top: y, left: x })

    if (first) {
      first = false
      $elem.css({
        right: 'auto',
        bottom: 'auto'
      })
    }
  }

  const upHandler = (evt: { stopPropagation?: any; cancelBubble?: boolean }) => {
    if (typeof endCallback === 'function') {
      endCallback()
    }

    document.removeEventListener('mousemove', moveHandler, true)
    document.removeEventListener('mouseup', upHandler, true)

    stopPropagation(evt)
  }

  document.addEventListener('mousemove', moveHandler, true)
  document.addEventListener('mouseup', upHandler, true)
}
